<script lang="ts">
  import { PRODUCTS, productKey } from '../lib/products';

  interface Props {
    value: string;
    onchange: (key: string) => void;
    label?: string;
  }

  const { value, onchange, label = 'Product' }: Props = $props();

  function handleChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    onchange(target.value);
  }
</script>

<label class="product-picker">
  <span class="muted">{label}</span>
  <select value={value} onchange={handleChange}>
    {#each PRODUCTS as p (p.jurisdiction + p.product)}
      <option value={productKey(p)}>{p.label} — {p.customerLabel}</option>
    {/each}
  </select>
</label>

<style>
  .product-picker {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--type-sm);
  }
  select {
    padding: var(--space-1) var(--space-2);
    border: 1px solid var(--surface-line);
    border-radius: var(--radius-sm);
    background: var(--surface-card);
    font-family: inherit;
    font-size: inherit;
  }
</style>
